export default {
	login: {
		loginInTitle: '客户报备系统',
		loginAccount: '请输入账号',
		loginPWD: '请输入密码',
		code: '验证码',
		rememberMe: '记住密码',
		AccountError: '请输入用户名',
		PWError: '请输入密码',
		codeError: '请输入验证码',
		login: '登录',
		privacyReadAndAgree: '我已阅读并同意',
		privacyPolicy: '《隐私政策》',
		privacyError: '请先同意隐私政策',
	},
	privacyPolicy: {
		title: '隐私政策',
		confirm: '我已阅读',
		loadError: '加载隐私政策失败，请稍后重试。',
	},
}
